import React from 'react';
import { Route } from 'react-router';

import entityRecommender from 'components/entityRecommender/entityRecommender.container';

const EntityRecommenderRoute = (
  <Route>
    <Route
      path='/entityRecommender'
      component={entityRecommender}
      >
      <Route
        path=':entityRecommenderId'
        component={entityRecommender}
        >
      </Route>
    </Route>
  </Route>
);

export default EntityRecommenderRoute;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.routes.jsx